import type { IHikCentralSuperConfigRepository } from '@yawi/domain';
import type {
  HikCentralOrganization,
  HikCentralSuperConfig,
  ReconcileOrgRequest,
  ReconcileOrgResponse,
  ReconcileOrgStatusResponse,
  UpdateHikCentralSuperConfigRequest,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

const BASE = 'v1/tenant/integrations';

export class ApiHikCentralSuperConfigRepository implements IHikCentralSuperConfigRepository {
  async getSuperConfig(integrationId: string, tenantId?: string): Promise<HikCentralSuperConfig> {
    const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return getApiClient().get<HikCentralSuperConfig>(`${BASE}/${integrationId}/super-config${qs}`);
  }

  async updateSuperConfig(
    integrationId: string,
    dto: UpdateHikCentralSuperConfigRequest,
    tenantId?: string,
  ): Promise<HikCentralSuperConfig> {
    const body = tenantId ? { ...dto, tenantId } : dto;
    return getApiClient().patch<HikCentralSuperConfig>(`${BASE}/${integrationId}/super-config`, body);
  }

  async getOrganizations(integrationId: string, tenantId?: string): Promise<HikCentralOrganization[]> {
    const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return getApiClient().get<HikCentralOrganization[]>(`${BASE}/${integrationId}/organizations${qs}`);
  }

  async reconcileOrg(dto: ReconcileOrgRequest, tenantId?: string): Promise<ReconcileOrgResponse> {
    const body = tenantId ? { ...dto, tenantId } : dto;
    return getApiClient().post<ReconcileOrgResponse>(`${BASE}/reconcile-org`, body);
  }

  async getReconcileStatus(tenantId?: string): Promise<ReconcileOrgStatusResponse> {
    const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return getApiClient().get<ReconcileOrgStatusResponse>(`${BASE}/reconcile-org/status${qs}`);
  }
}
